module.exports = __webpack_public_path__ + "static/media/stripem2.a5d0a977.png";